import api from 'Utility/api';
import type {
  IncentivePlanDeal,
  IncentivePlanInvestor,
} from 'Types/incentivePlan/incentiveTypes';
import type {RequestOptions} from 'Types/api';
import {ApiTarget} from 'Types/api';

export const getInvestorPriceDetailsJwt = async (
  dealId: number | string,
  jwt: string
): Promise<IncentivePlanInvestor> => {
  const whitelistedDomain = document.location.href;

  const init: RequestInit = {
    headers: {
      'X-DEALMAKER-DOMAIN': whitelistedDomain,
    },
  };

  const params = new URLSearchParams({
    token: jwt,
  });

  return await api.getJson<IncentivePlanInvestor>(
    ApiTarget.EmbedV1,
    `deals/${dealId}/investors/price_details?${params}`,
    init,
    {anonymous: true}
  );
};

export const getIncentivePlanDeal = async (
  dealId: number | string
): Promise<IncentivePlanDeal> => {
  const whitelistedDomain = document.location.href;

  const payload: RequestInit = {
    headers: {
      'Content-Type': 'application/json',
      'X-DEALMAKER-DOMAIN': whitelistedDomain,
    },
  };

  const options: RequestOptions = {
    anonymous: true,
  };

  return await api.getJson<IncentivePlanDeal>(
    ApiTarget.V1,
    `deals/${dealId}/incentive_plan`,
    payload,
    options
  );
};
